import { getLabelTextForModelType } from "helpers/utility/enrichmentUtilities";
import { SelectionAlertModel } from "types";
import styles from "./style.module.scss";
import { ModelTypes } from "types";

// Helper function for building the sub title and decription
export const createContent = (model: SelectionAlertModel): JSX.Element => {
  let subTitleText = "";
  let description: JSX.Element | string = "";

  const { selectionType, type } = model;

  const isAlert = selectionType === "alert";
  const isSemanticObjectModel =
    isAlert && type === ModelTypes.MULTIMODEL_OBJECT_ENCODING;

  const labelText = getLabelTextForModelType(model.type);
  const overrideText = `This operation will cause ${labelText} generated by ${model.name} to override any existing ${labelText}.`;

  if (isAlert) {
    if (isSemanticObjectModel) {
      subTitleText =
        "To use Semantic Object Search effectively, your dataset should include detected objects.";
      description = (
        <span
          className={styles.description}
          data-testid="selection-alert-model-description"
        >
          If no objects are found, the model won’t return any results - the run
          will be wasted.
          <br />
          <br />
          No objects yet?
          <br />
          Run our VL-Object-Detector model first to enable this enrichment.
        </span>
      );
    } else {
      subTitleText = "Please make sure you have selected the related models.";
      description = (
        <span
          className={styles.description}
          data-testid="selection-alert-model-description"
        >
          Ensure that the necessary models are selected to proceed with the
          operation.
        </span>
      );
    }
  } else {
    subTitleText = "Are you sure you want to proceed with this operation?";
    description = (
      <span
        className={styles.description}
        data-testid="selection-alert-model-description"
      >
        {overrideText}
      </span>
    );
  }

  return (
    <>
      <div
        className={styles.subtitle}
        data-testid="selection-alert-model-subTitle"
      >
        {subTitleText}
      </div>
      {description}
    </>
  );
};
